export default __webpack_public_path__ + "static/media/github.32d26b80.png";